import { render, staticRenderFns } from "./InsMediaPopGallery.vue?vue&type=template&id=66722fbe&scoped=true&"
import script from "./InsMediaPopGallery.vue?vue&type=script&lang=ts&"
export * from "./InsMediaPopGallery.vue?vue&type=script&lang=ts&"
import style0 from "./InsMediaPopGallery.scss?vue&type=style&index=0&id=66722fbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66722fbe",
  null
  
)

export default component.exports